import React, { useState, useEffect } from 'react';

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Rich editor
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

//API
import ayarlarGetAPI from '../../services/ayarlarGet';
import ayarlarUpdateAPI from '../../services/ayarlarUpdate';

const Ayarlar = () => {
  const [gbposta, setGbeposta] = useState(false);
  const [gbsms, setGbsms] = useState(false);
  const [eposta, setEposta] = useState('');
  const [sifre, setSifre] = useState('');
  const [baslik, setBaslik] = useState('');
  const [metin, setMetin] = useState('');

  const handleFormSubmit = async () => {
    const data = {
      Email: gbposta,
      SMS: gbsms,
      SupportMailAdress: eposta,
      SupportMailBody: metin,
      SupportMailPassword: sifre,
      SupportMailSubject: baslik,
    };

    const updateAyarlar = await ayarlarUpdateAPI(data);
    if (updateAyarlar.status === 200) {
      return toast.success('İşlem başarılı', {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      return toast.error('Hata oluştur. Lütfen daha sonra tekrar deneyiniz', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  //Fetch Data AYARALAR
  const fetchAyarlar = async () => {
    const ayarlar = await ayarlarGetAPI();

    if (ayarlar.status === 200) {
      setGbeposta(ayarlar.data[0].Email);
      setGbsms(ayarlar.data[0].SMS);
      setEposta(ayarlar.data[0].SupportMailAdress);
      setSifre(ayarlar.data[0].SupportMailPassword);
      setBaslik(ayarlar.data[0].SupportMailSubject);
      setMetin(ayarlar.data[0].SupportMailBody);
    }
  };

  useEffect(() => {
    fetchAyarlar();
    // eslint-disable-next-line
  }, []);

  console.log(gbposta + 'Setlendi');

  return (
    <main className="text-slate-500 text-sm">
      <ToastContainer />
      <div className="py-5">
        <div className="w-full px-4 sm:px-6 md:px-8">
          <div className="container mx-auto">
            <h1 className="page-title leading-6 font-normal text-lg mb-6 text-slate-500 ">
              Sistem Ayarları ve Tanımlar
            </h1>
          </div>

          <div className="container max-w-4xl mx-6 mb-6">
            <div className="bg-slate-100  w-full p-4 rounded-tl-lg rounded-lg flex flex-col gap-y-6">
              <div>
                <h1 className="mb-2 font-semibold">Geri bildirim</h1>
                <div className="relative flex items-start">
                  <div className="flex h-6 items-center">
                    <input
                      checked={gbposta}
                      onChange={(e) => {
                        setGbeposta(e.target.checked);
                      }}
                      id="gbeposta"
                      name="comments"
                      type="checkbox"
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                  </div>
                  <div className="ml-3 text-sm leading-6">
                    <label htmlFor="gbeposta">E-Posta</label>
                  </div>
                </div>
                <div className="relative flex items-start">
                  <div className="flex h-6 items-center">
                    <input
                      checked={gbsms}
                      onChange={(e) => {
                        setGbsms(e.target.checked);
                      }}
                      id="gbsms"
                      name="gbsms"
                      type="checkbox"
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                  </div>
                  <div className="ml-3 text-sm leading-6">
                    <label htmlFor="comments">SMS</label>
                  </div>
                </div>
              </div>
              <div>
                <h1 className="mb-2 font-semibold">Sistem E-Posta Ayarları</h1>

                <div className="flex flex-col gap-y-2">
                  <div>
                    <label>E-Posta Adresi</label>
                    <input
                      value={eposta}
                      onChange={(e) => setEposta(e.target.value)}
                      type="email"
                      placeholder=""
                      className="w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all"
                    />
                  </div>
                  <div>
                    <label>Şifre</label>
                    <input
                      value={sifre}
                      onChange={(e) => setSifre(e.target.value)}
                      type="password"
                      placeholder=""
                      className="w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all"
                    />
                  </div>
                </div>
              </div>

              <div>
                <h1 className="mb-2 font-semibold">Sistem E-Posta Ayarları</h1>

                <div className="flex flex-col gap-y-2">
                  <div>
                    <label>Geri bildirim e-posta başlığı</label>
                    <input
                      value={baslik}
                      onChange={(e) => setBaslik(e.target.value)}
                      type="text"
                      placeholder=""
                      className="w-full 0  text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all"
                    />
                  </div>
                  <div className="relative">
                    <label>Geri bildirim e-posta metni</label>
                    <div className="bg-white pb-10">
                      <ReactQuill
                        className="h-40"
                        theme="snow"
                        value={metin}
                        onChange={setMetin}
                      />
                    </div>
                    <p>
                      Mail metninde kullanabileceğiniz dinamik parametreler
                      şunlardır:
                      <br />
                      <code className="text-xs">[%basvuruNo%]</code>
                      <code className="text-xs">[%arastirmaciAdiSoyadi%]</code>
                      <code className="text-xs">[%arastimarciUnvani%]</code>
                      <code className="text-xs">[%arastirmaBasligiTR%]</code>
                      <code className="text-xs">[%SupportMailAdress%]</code>
                    </p>
                  </div>
                </div>
                <div className="flex mt-4">
                  <button
                    onClick={() => handleFormSubmit()}
                    className="w-full text-xs h-10 text-white bg-slate-500   hover:bg-slate-500/80 leading-5 px-6 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all"
                  >
                    KAYDET
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Ayarlar;
